import './bank-reviews/search-filter'
import './apps/bankrate-cookie'

import {
  generateProductListViewedEvent,
  sendProductClickedEvent,
  sendElementClickedEvent,
  sendTabElementClickedEvent,
  addProductViewed,
  generateUuid
} from './bankrate-tracking/bankrate-reviews'
import { processcookieName } from './apps/utility/cookie'

// Set a viewThroughCookie
processcookieName('Bank Review', 'viewThroughBankReview', window.purchaseId)

// Render Tabbed Products
let tabs = Array.from(document.querySelectorAll('.tabs > li'))

if (tabs.length) {
  // For product variations test
  let tabsVariations = Array.from(
    document.querySelectorAll('.tabs__link--variations')
  )
  let hiddenPanes = Array.from(
    document.querySelectorAll('.feature__data > div:not(:first-child)')
  )
  tabs.forEach(function(element) {
    element.addEventListener('click', clickOnTabs)
  })

  hiddenPanes.forEach(function(element) {
    element.classList.add('is-hidden')
  })

  tabs[0].className += ' --is-active'
  // For product variations test
  if (tabsVariations.length) {
    tabsVariations[0].className += ' --is-active'
  }
  let value = tabs[0].getAttribute('value')
  document.getElementById(value).classList.add('is-visible')
}

// Generate Tagular Events
window.addEventListener('DOMContentLoaded', () => {
  setProductId()
  addProductViewed()
  generateProductListViewedEvent(true)
  setTagularClickEventsOnProducts()
})

function clickOnTabs() {
  let tabs = Array.from(document.querySelectorAll('.tabs > li'))
  let featureBlock = Array.from(
    document.querySelectorAll('.feature__data > div')
  )

  tabs.forEach(function(el) {
    el.classList.remove('--is-active')
    featureBlock.forEach(function(element) {
      element.classList.remove('is-visible')
      element.classList.add('is-hidden')
    })
    el.addEventListener('click', sendTabElementClickedEvent)
  })

  this.className += ' --is-active'

  let sectionName = this.getAttribute('value')
  document.getElementById(sectionName).classList.add('is-visible')
  document.getElementById(sectionName).classList.remove('is-hidden')
}

function setTagularClickEventsOnProducts() {
  let buttons = Array.from(document.querySelectorAll('.product--button'))
  buttons.forEach(function(element) {
    element.addEventListener('click', sendProductClickedEvent)
  })
}

/*
 * Fix condition where DOMContentLoaded gets called before this
 * script is ran so our buttons never get the click event added to handle
 * product clicks
 */
let counter = 10
const intervalId = setInterval(() => {
  setTagularClickEventsOnProducts()
  counter--
  if (counter === 0) {
    window.clearInterval(intervalId)
  }
}, 3000)

setTagularElementClickEvents()

function setTagularElementClickEvents() {
  let reviewLinks = Array.from(document.querySelectorAll('.bank-review-link'))
  reviewLinks.forEach(function(link) {
    link.addEventListener('click', sendElementClickedEvent)
  })
}

function setProductId() {
  let products = Array.from(document.querySelectorAll('.rate-product'))

  let modifiedProducts = []
  products.map(product => {
    modifiedProducts.push((product.dataset.productId = generateUuid()))
  })
}
